<svelte:options customElement="hb-dashboard-indicator" />

<script lang="ts">
  /**
   * Svelte Dashboard Indicator WebComponent
   * =====================
   *
   * @contributors: Dario Caruso <dev@dariocaruso.info> (https://dariocaruso.info)
   *
   * @license: MIT License
   *
   */
  import type { Component } from "./types/webcomponent.type";

  function dispatch(name: string, detail: any) {
    $host().dispatchEvent(new CustomEvent(name, { detail }));
  }

  let {
    id = "",
    // style,
    number = 0,
    text = "",
    link_label = "",
    icon = "hypnotize",
  }: Component = $props();
</script>

<svelte:head>
  <link
    rel="stylesheet"
    href="https://cdn.jsdelivr.net/npm/bootstrap-icons@latest/font/bootstrap-icons.css"
  />
</svelte:head>

<div class="panel panel-green">
  <div class="panel-heading">
    <div class="row">
      <div><i id="icon" class="bi bi-{icon}"></i></div>
      <div id="panel-heading-content">
        <div id="number">{number}</div>
        <div>{text}</div>
      </div>
    </div>
  </div>
  {#if link_label}
    <!-- svelte-ignore a11y_click_events_have_key_events -->
    <!-- svelte-ignore a11y_no_static_element_interactions -->
    <div
      onclick={() => {
        dispatch("dashboardIndicatorClick", {
          id,
        });
      }}
      class="panel-footer"
    >
      <span class="pull-left">{link_label}</span><span style="float:right"
        ><i class="bi bi-arrow-right-circle-fill"></i></span
      >
      <div class="clearfix"></div>
    </div>
  {/if}
</div>

<style lang="scss">
  @forward "./styles/webcomponent.scss";
</style>
